import {
  adminRhythmOverviewSchema,
  adminUserRhythmSchema,
  type AdminRhythmOverview,
  type AdminUserRhythm,
  type RhythmBaselineArm,
} from '@steado/admin-contract/rhythm';
import { queryOptions } from '@tanstack/react-query';

import type { ApiClient } from '@/lib/api/client';

/** [arm] narrows the baseline; everything else on the screen counts everyone. */
export function rhythmOverviewQueryOptions(api: ApiClient, arm: RhythmBaselineArm = 'all') {
  return queryOptions({
    queryKey: ['admin', 'rhythm', 'overview', arm],
    queryFn: (): Promise<AdminRhythmOverview> =>
      api.request({
        path: '/admin/rhythm/overview',
        query: arm === 'all' ? {} : { arm },
        schema: adminRhythmOverviewSchema,
      }),
  });
}

export function userRhythmQueryOptions(api: ApiClient, userId: string) {
  return queryOptions({
    queryKey: ['admin', 'user', userId, 'rhythm'],
    queryFn: (): Promise<AdminUserRhythm> =>
      api.request({ path: `/admin/users/${userId}/rhythm`, schema: adminUserRhythmSchema }),
  });
}
